<div class="animated fadeIn pb-5">
    <div class="firstSection p-2 text-center">
        <h3 class="fw-sbold my-2 text-white fs-22">Mis proyectos en proceso de fondeo</h3>
    </div>

    <div class="secondSection my-5" *ngFor="let projects of actualProjects; let i = index;">
        <div class="d-flex align-items-center">
            <div class="image col-3">
                <img [src]="projects?.images[0]" alt="IMG Project" class="w-100">
            </div>
            <div class="text ms-4 col-8">
                <h1 class="cl-blue-n1 fs-18 fw-xbold">{{projects?.name }}</h1>
                <div class="d-flex align-items-center justify-content-between">
                    <p class="cl-grey-n1 fs-13 my-1">Fondeo actual:</p>
                    <span class="cl-primary fw-sbold fs-13">
                        ${{ (projects?.participationsTotal - projects?.participationsFree) * projects?.participationValue | number }} 
                        de
                        ${{ projects?.participationsTotal * projects?.participationValue | number }}
                    </span>
                </div>
                <div class="d-flex align-items-center justify-content-between">
                    <p class="cl-grey-n1 fs-13 my-1">Monto confirmado previamente:</p>
                    <span class="cl-primary fw-sbold fs-13">
                        ${{ projects?.amountWithDraw | number }}
                    </span>
                </div>
                <div class="d-flex align-items-center justify-content-between">
                    <p class="cl-grey-n1 fs-14 my-1">Monto disponible:</p>
                    <span class="cl-secundary fs-16 fw-bold">
                        ${{ -(projects?.amountWithDraw - (projects?.participationsTotal - projects?.participationsFree) * projects?.participationValue) | number }}
                    </span>
                </div>

                <button class="btn-white btn my-3" (click)="setActiveIndex(i)" *ngIf="-(projects?.amountWithDraw - (projects?.participationsTotal - projects?.participationsFree) * projects?.participationValue) > 1">
                    Solicitar recursos
                    <img src="assets/icons/arrow-icon-down.svg" alt="#" class="ms-1">
                </button>

            </div>
        </div>
        <mnf-info [idProject]="projects?.id" (hideInfoEvent)="setActiveIndex($event)" [index]="indexToShowInfo" *ngIf="indexToShowInfo === i"></mnf-info> 
    </div>
</div>